import { useCallback, useEffect, useRef, useState } from 'react';
import core from '@gin-betting/core';
import { debounce } from 'lodash';

import { useMemoSelector } from 'hooks';

const {
    entities: {
        selectors: { selectOddWithAvailability },
    },
} = core;

const TIMEOUT = 600;

interface Input {
    oddId: string;
}

interface Output {
    isActive: boolean;
    showHistory: boolean;
    onMouseLeave: () => void;
    onMouseEnter: () => void;
}

const useMouseEventsHandler = ({ oddId }: Input): Output => {
    const { isActive } = useMemoSelector(selectOddWithAvailability, { oddId });
    const [showHistory, setShowHistory] = useState<boolean>(false);

    const timer = useRef<NodeJS.Timeout>(0 as any);

    const onMouseEnter = useCallback(() => {
        debounce(() => {
            clearTimeout(timer.current);

            timer.current = setTimeout(() => {
                setShowHistory(true);
            }, TIMEOUT);
        }, 100)();
    }, []);

    const onMouseLeave = useCallback(() => {
        debounce(() => {
            clearTimeout(timer.current);
            setShowHistory(false);
        }, 100)();
    }, []);

    useEffect(() => () => clearTimeout(timer.current), []);

    return {
        isActive,
        showHistory,
        onMouseLeave,
        onMouseEnter,
    };
};

export default useMouseEventsHandler;
